import { Typography } from 'antd';
import React, { useMemo } from 'react';

import { TaskBoardColumnsType } from '../taskBoardTypes';

export interface TaskBoardColumnHeadersProps {
    columns: TaskBoardColumnsType;
}

export const TaskBoardColumnHeaders: React.FC<TaskBoardColumnHeadersProps> = ({ columns }) => {
    return useMemo(() => {
        return (
            <div
                style={{
                    position: 'sticky',
                    height: 48,
                    top: 0,
                    zIndex: 1000,
                    display: 'flex',
                    width: '100%',
                    gap: 8,
                    overflow: 'hidden',
                }}
            >
                {Object.entries(columns).map(([columnId, column]) => (
                    <div
                        style={{
                            flex: '1 1 300px',
                            background: 'white',
                            minWidth: 200,
                        }}
                        key={`h-${columnId}`}
                    >
                        <div
                            style={{
                                padding: 8,
                                paddingTop: 0,
                                height: 48,
                                background: '#f7f8f9',
                                borderTopLeftRadius: 16,
                                borderTopRightRadius: 16,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Typography.Text strong style={{ fontSize: 16 }}>
                                {column.name}
                            </Typography.Text>
                        </div>
                    </div>
                ))}
            </div>
        );
    }, [columns]);
};
